<script>
  import AXHR from "../components/js/axhr.js";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  //TABLE SECTION
  import Modal from "../components/Modal.svelte";
  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] !== filter.value;
          });
        } else {
          res = res;
        }
        dataFiltered = res;
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  if (sessions) {
    loadData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-ip-binding",
      sessions.token,
      false
    );
  }

  let selection = [];
  let selectionUser = [];
  let deleteSelected = false;

  $: console.log(selectionUser);
  $: if (selection.length > 0) {
    document.getElementById("selectAll").indeterminate = true;
    if (selection.length === dataFiltered.length) {
      setTimeout(() => {
        document.getElementById("selectAll").indeterminate = false;
      }, 100);
      document.getElementById("selectAll").checked = true;
    }
    deleteSelected = true;
  } else if (selection.length === 0) {
    setTimeout(() => {
      if (document.getElementById("selectAll")) {
        document.getElementById("selectAll").indeterminate = false;
      }
    }, 100);
    deleteSelected = false;
  }
  function SelectAll(state, css) {
    for (var i = 0; i < dataFiltered.length; i++) {
      if (document.getElementsByClassName(css)[i]) {
        document.getElementsByClassName(css)[i].checked = state;
        if (state == true) {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;
          selection = [
            ...selection,
            document.getElementsByClassName(css)[i].value,
          ];

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
          selectionUser = [
            ...selectionUser,
            document.getElementsByClassName(css)[i].getAttribute("data-user"),
          ];
        } else {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
        }
      }
    }
  }

  function SelectData(e) {
    if (e.target.checked == true) {
      console.log("kclas");
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;
      selection = [...selection, e.target.value];

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
      selectionUser = [...selectionUser, e.target.dataset.user];
    } else {
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
    }
  }
  function deleteSelectedUser(selection) {
    loading = true;
    let data = {
      selection: selection,
    };

    var config = {
      method: "delete",
      url:
        sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/hotspot/ip-binding/mass",
      headers: {
        Authorization: "Bearer " + sessions.token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        setTimeout(() => {
          document.getElementById("selectAll").indeterminate = false;
        }, 100);
        document.getElementById("selectAll").checked = false;
        SelectAll(false, "idUser");
        if (response.data.length != undefined) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.length + " Pengaturan Berhasil dihapus",
              color: "green",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message:
                "Pengaturan " + response.data.comment + " Berhasil dihapus",
              color: "green",
            },
          ];
        }
        loading = false;
        loadData(
          sessions.api +
            "/rb/" +
            sessions.routeractive.id +
            "/ip-hotspot-ip-binding",
          sessions.token,
          false
        );
      })
      .catch(function (error) {
        loading = false;
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  let loading = false;

  let loadTable = false;
  setTimeout(() => {
    loadTable = true;
  }, 1000);

  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Hotspot Binding</title>
</svelte:head>
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20"
>
  <Title
    title="Hotspot Binding"
    subtitle="Manage Your Hotspot Binding"
    tipe="3"
    href="./"
  />
  <div class="mx-auto my-2 lg:my-2">
    <div class="relative block w-full gap-8 lg:flex md:block">
      <!--/FORM SECTION-->
      <div class="w-full px-2 pt-5 pb-10 my-5 bg-white rounded-lg shadow-lg">
        <!--TABLE SECTION-->
        {#if loadTable}
          <MakeSortable
            data={dataFiltered}
            let:table
            {filter}
            filterFields={[
              "name",
              "macAddress",
              "address",
              "toAddress",
              "comment",
            ]}
            sortIconCss={imgsortIconCss}
            sortIconAscCss={imgsortIconAscCss}
            sortIconDescCss={imgsortIconDescCss}
          >
            <div
              class="flex flex-wrap items-center justify-between w-full pr-2 mb-2"
            >
              <div
                class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6"
              >
                {#if deleteSelected}
                  <Modal backdropClose size="lg:w-2/5 w-full z-50">
                    <div class="mt-0 lg:mt-0 md:mt-4" slot="trigger" let:open>
                      {#if loading}
                        <button
                          on:click|preventDefault
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 bg-opacity-50 rounded-md focus:outline-none hover:bg-red-500"
                          disabled>Memproses...</button
                        >
                      {:else}
                        <button
                          on:click={open}
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                          >Delete Selected <i>({selection.length})</i></button
                        >
                      {/if}
                    </div>

                    <div slot="header">
                      <h1 class="text-lg">Delete This List ...?</h1>
                    </div>
                    <div slot="content" class="h-full">
                      <div class="w-full rounded-lg lg:px-2">
                        <div
                          class="flex gap-2 overflow-y-auto"
                          style="height:60vh"
                        >
                          <div class="w-1/2">
                            <table class="w-full table-fixed">
                              <thead class="w-full">
                                <th
                                  class="w-1/3 px-2 py-1 text-sm text-center bg-white border-b border-r border-gray-300"
                                  >#</th
                                >
                                <th
                                  class="w-2/3 px-2 py-1 text-sm text-center truncate whitespace-pre-wrap bg-white border-b border-r border-gray-300"
                                  >Name</th
                                >
                              </thead>
                              <tbody>
                                {#each selectionUser as s, i}
                                  <tr class="w-full hover:bg-gray-200">
                                    <td
                                      class="w-1/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{i + 1}</td
                                    >
                                    <td
                                      title={s}
                                      class="w-2/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{s}</td
                                    >
                                  </tr>
                                {/each}
                              </tbody>
                            </table>
                          </div>
                          <div class="sticky top-0 w-1/2 text-center">
                            <p
                              class="px-2 py-3 mx-2 mb-5 text-sm text-center text-red-800 bg-yellow-200 rounded"
                            >
                              The following is a list of users who will be
                              deleted, please make sure first
                            </p>
                            <button
                              on:click|preventDefault={() =>
                                deleteSelectedUser(selection)}
                              on:click={() =>
                                document
                                  .getElementsByClassName("backdrop")[0]
                                  .click()}
                              class="px-2 py-1 text-sm text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                              >Delete Now <i>({selection.length})</i></button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                {:else}
                  <div class="mt-0 lg:mt-0 md:mt-4">
                    <button
                      on:click={() =>
                        loadData(
                          sessions.api +
                            "/rb/" +
                            sessions.routeractive.id +
                            "/ip-hotspot-ip-binding",
                          sessions.token,
                          { name: "default", value: true }
                        )}
                      class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
                      ><svg
                        class="inline w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg> Refresh</button
                    >
                  </div>
                {/if}
              </div>
              <div
                class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
              >
                <span>Total : <b>{table.rows.length}</b></span><span
                  >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
                >
              </div>
              <input
                type="text"
                class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
                placeholder="Search..."
                bind:value={filter}
              />
            </div>

            <div class="w-full">
              <div
                transition:fade
                class="sticky z-10 w-full mb-5 bg-gray-100 border-b-4 border-gray-400 rounded-lg shadow-lg lg:shadow-lg md:shadow-lg lg:top-20 md:top-20 top-16"
              >
                <div
                  class="flex flex-no-wrap items-end justify-start w-full overflow-x-auto cursor-pointer lg:items-center md:items-end"
                >
                  <div class="w-8 p-2 text-sm italic font-bold">
                    <label for="selectAll">
                      <input
                        on:click={(e) => SelectAll(e.target.checked, "idUser")}
                        type="checkbox"
                        id="selectAll"
                        class="mx-1 my-1 text-xl rounded-lg form-checkbox hover:shadow-outline"
                      />
                    </label>
                  </div>
                  <SortHeader
                    css="w-72 p-2 text-sm font-bold italic"
                    path={(row) => String(row.comment)}>Name</SortHeader
                  >
                  <SortHeader
                    css="w-40 p-2 text-sm font-bold italic"
                    path={(row) => String(row.macAddress)}
                    >Mac Adrress</SortHeader
                  >
                  <SortHeader
                    css="w-40 p-2 text-sm font-bold italic"
                    path={(row) => String(row.address)}>IP Address</SortHeader
                  >
                  <SortHeader
                    css="w-40 p-2 text-sm font-bold italic"
                    path={(row) => String(row.toAddress)}>To Address</SortHeader
                  >
                </div>
              </div>

              <div class="w-full">
                {#if table.pageRows.length > 0}
                  {#each table.pageRows as d}
                    <div
                      class="w-full mx-0 my-2 overflow-hidden rounded-lg shadow-md lg:my-1 md:my-1 hover:bg-gray-100"
                    >
                      <label
                        for="select-{d.name}"
                        class="flex flex-wrap items-center justify-start w-full"
                      >
                        <div class="w-8 p-2 text-sm">
                          {#if selection.some(function (el) {
                            return el == d.id;
                          })}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.id}"
                              data-user={d.comment +
                                " # " +
                                d.macAddress +
                                " # " +
                                d.address}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                              selected
                            />
                          {:else}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.id}"
                              data-user={d.comment +
                                " # " +
                                d.macAddress +
                                " # " +
                                d.address}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                            />
                          {/if}
                        </div>
                        <div class="p-2 text-sm w-72">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Name
                          </div>
                          {#if d.disabled}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              class="inline w-4"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                              />
                            </svg>
                          {/if}
                          {#if d.comment}
                            {String(d.comment)}
                          {:else}
                            -
                          {/if}
                        </div>

                        <div class="w-40 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Mac Address
                          </div>
                          {#if d.macAddress}
                            {String(d.macAddress)}
                          {:else}
                            -
                          {/if}
                        </div>

                        <div class="w-40 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            IP Address
                          </div>

                          {#if d.address}
                            {d.address}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-40 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            To Address
                          </div>

                          {#if d.toAddress}
                            {d.toAddress}
                          {:else}
                            -
                          {/if}
                        </div>
                      </label>
                    </div>
                  {/each}
                {:else}
                  {#if filter}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {:else}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {/if}

                  <div class="flex items-center justify-center w-full h-full">
                    <div class="text-center">
                      <img
                        src="./assets/logo/logo_icon.svg"
                        alt="Mikhub Loading"
                        class="w-20 h-20 mx-auto animate-spin"
                        width="50"
                        height="50"
                      />
                    </div>
                  </div>
                {/if}
              </div>
            </div>
            <div
              class="flex flex-no-wrap items-center justify-center w-full my-5 rounded-lg"
            >
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-l-lg shadow"
                class:bg-gray-300={table.paging.currentPage === 0}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onPrevious}>&laquo;</button
                >
              </div>
              {#each table.paging.buttons as btn (btn)}
                <div
                  class="flex items-center justify-center w-10 h-10 bg-white shadow"
                  class:bg-gray-300={btn.active}
                >
                  <button
                    class="w-full h-full focus:outline-none"
                    on:click={btn.onClick}>{btn.label}</button
                  >
                </div>
              {/each}
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-r-lg shadow"
                class:bg-gray-300={table.paging.currentPage >=
                  table.paging.pageCount - 1}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onNext}>&raquo;</button
                >
              </div>
            </div>
          </MakeSortable>
        {:else}
          <div class="flex items-center justify-center w-full h-full">
            <div class="text-center">
              <img
                src="./assets/logo/logo_icon.svg"
                alt="Mikhub Loading"
                class="w-20 h-20 mx-auto animate-spin"
                width="50"
                height="50"
              />
              <span class="italic text-gray-900 animate-pulse text-md"
                >loading</span
              >
            </div>
          </div>
        {/if}
        <!--/TABLE SECTION-->
      </div>
    </div>
  </div>
</main>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-50 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
